import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
// eslint-disable-next-line no-unused-vars
import { Link } from 'react-router-dom';
import Select from 'react-select';
import ErrorModal from '../../../components/misc/ErrorModal';

import BreadCrumbs from '../../../layouts/breadcrumbs/BreadCrumbs';

import ComponentCard from '../../../components/ComponentCard';
import { userGroupsApi } from '../../../components/api/user/UserGroupsApi';

import { handleLogError } from '../../../components/misc/Helpers';
import { websiteApi } from '../../../components/api/infra/WebsitesApi';
import useTableState from '../../../components/useTableState';
import WebsiteSelect from '../../../components/formElements/websiteSelect';


const UserGroupsTable = () => {
  const [
    // eslint-disable-next-line no-unused-vars
    keycloakState, modal, setModal, toggleModal, errorState, setErrorState, showError, hideError, obj, setObj, handleFieldChange, tableState, setTableState,
  ] = useTableState();

  const [websites, setWebsites] = useState([]);  //edit form
  const [websiteUuid, setWebsiteUuid] = useState("");

  const handleGetRows = async () => {
    try {
      if (websites.length === 0)
        websiteApi.list(keycloakState.token).then(response => setWebsites(response.data));

      const response = await userGroupsApi.listByWebsite(websiteUuid, keycloakState.token);
      setTableState((prev) => ({...prev, data : response.data, status : "", loading: false }));
    } catch (error) {
      setTableState((prev) => ({...prev,...tableState, status : `Error: ${error}` }));
      handleLogError(error)
    }
  }
  const handleWebsiteChange = (value) => {
    setObj((prev) => ({...prev, websiteUuid: value.uuid}));
  };

  const handleSubmit = async (event) => {
    setTableState((prev) => ({ ...prev, loading:true }));
    event.preventDefault();
    await userGroupsApi.save( obj, keycloakState.token);

    await handleGetRows();
    setModal(false);
  };

  useEffect(() => {
    handleGetRows();
  }, [websiteUuid]);

  return (
    <div>
      <BreadCrumbs />
      <ErrorModal/>
      <Modal isOpen={errorState.visible} toggle={hideError.bind(null)}>
        <ModalHeader toggle={hideError.bind(null)}>{errorState.title}</ModalHeader>
        <ModalBody>
          {errorState.text}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={hideError.bind(null)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal} toggle={toggleModal.bind(null)}>
        <ModalHeader toggle={toggleModal.bind(null)}>Edit group</ModalHeader>
        <ModalBody>
          <Form onSubmit={(event) => handleSubmit(event)} id="editForm">
            <Input type='hidden' name='id' id='id' defaultValue={obj.id} />
            <Input type='hidden' name='uuid' id='uuid' defaultValue={obj.uuid} />
            <FormGroup>
              <p>UUID:{obj.uuid}</p>
            </FormGroup>
            <Row>
              <Col md='4' className='text-end'>
                Website:
              </Col>
              <Col md='8'>
                {websites !== undefined && (<Select
                  name="website"
                  onChange={handleWebsiteChange}
                  options={websites} // here
                  // defaultValue={{ name: "Monstasks", uuid: "cfe5fc05-44ad-4a9d-9219-9196d513974b" }}
                  defaultValue={websites.find((o) => o.uuid === obj.websiteUuid)}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.uuid}
                  clearable={false}
                />)}
              </Col>
            </Row>
            <FormGroup>
              <Label for='login'>code</Label>
              <Input type='text' name='code' id='code' defaultValue={obj.code}  onChange={handleFieldChange} />
            </FormGroup>
            <FormGroup>
              <Label for='name'>Name</Label>
              <Input type='text' name='name' id='name' defaultValue={obj.name} onChange={handleFieldChange} />
            </FormGroup>
            <FormGroup>
              <Button color='primary' type='submit' disabled={tableState.loading}>
                Save
              </Button>
              <Button color='secondary' className='ml-1' onClick={toggleModal.bind(null)}>
                Cancel
              </Button>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
      {/*--------------------------------------------------------------------------------*/}
      {/* Start Action table*/}
      {/*--------------------------------------------------------------------------------*/}
      <ComponentCard title='Users groups'>
        <Row className="p-1">
          <Col md='2'>
            <Button color='primary' className='ml-1' onClick={() => {
              setObj({ id: -1, code: '', name: '', uuid: '', websiteUuid });
              setModal(true);
            }}>
              New
            </Button>
          </Col>
          <Col md='4'>
            <p>{tableState.status}</p>
          </Col>
          <Col md='6'>
            <WebsiteSelect websiteUuid={websiteUuid} setWebsiteUuid={setWebsiteUuid}/>
          </Col>
        </Row>

        <ReactTable
          columns={[
            {
              Header: 'ID',
              accessor: 'id',
              width: 50,
            },
            {
              Header: 'UUID',
              accessor: 'uuid',
              width: 150,
              // Cell: e => {
              //   console.log(e) // viewIndex here
              //   return (<Link to={e.original.uuid}>{e.original.uuid}</Link>)
              // }
              // render:  ({ row })  => (<Link to={row.uuid}>{row.uuid}</Link>)
            },
            {
              Header: 'Code',
              accessor: 'code',
              width: 150,
            },
            {
              Header: 'Name',
              accessor: 'name',
              width: 150,
            },
            {
              Header: 'Actions',
              accessor: 'uuid',
              sortable: false,
              filterable: false,
              Cell: e => {
                return (
                  <div className="text-end">
                    <Button
                      color='primary'
                      size='sm'
                      round='true'
                      icon='true'
                      onClick={() => {
                        // alert(id);
                        const sobj = tableState.data.find((o) => o.id === e.original.id);
                        setObj(sobj);
                        setModal(true);
                      }}
                    >
                      <i className='fa fa-edit' />Edit
                    </Button>
                    &nbsp;
                    <Button onClick={async () => {
                      await userGroupsApi.remove(e.original.uuid, keycloakState.token).catch(er => showError("Cannot delete user group", er));
                      await handleGetRows();
                    }}
                            className='ml-1' color='danger' size='sm' round='true' icon='true' ml>
                      <i className='fa fa-times' />Delete</Button>
                  </div>
                );
              },

            },
          ]}
          defaultPageSize={10}
          showPaginationBottom
          className='-striped -highlight'
          data={tableState.data}
        />
      </ComponentCard>
      {/*--------------------------------------------------------------------------------*/}
      {/* End Action table*/}
      {/*--------------------------------------------------------------------------------*/}
    </div>
  );
};

export default UserGroupsTable;
